import { z } from 'zod';

export const campusesSchema = z.object({
  items: z
    .array(
      z.object({
        label: z.string().min(1),
        placeholder: z.boolean().optional(),
      }),
    )
    .min(1),
});

export type Campuses = z.infer<typeof campusesSchema>;
